import { Navigate, useParams } from "react-router-dom";
import { Fragment, useEffect, useState } from 'react';
import './OC.css';
import VandalismCharacters from "./VandalismCharacters";
import NecrocomicheCharacters from "./NecrocomicheCharacters";
import ResidentsOfAIONCharacters from "./ResidentsOfAIONCharacters";

const WORLDS = [
    {
        worldName: "VANDALISM101",
        description: ["어느 대학 부속 기밀 연구기관 이야기. 윤리도 상식도 도덕도 없는 미치광이 생존기.", "본편　게임 「VANDALISM101」제작중."],
        logo: "VANDALISM101 logo.webp",
        characterData: VandalismCharacters,
        characters: ["Bishop", "Dmitri", "Haze", "Professor", "Ivan", "Wei", "Surgeon", "Rondo", "Alexey", "Necro",
            "Miranda", "Kumo", "Ilya", "Wondertain", "Agatha", "Rebecca", "Therapist", "Demian", "SAZANG", "Choi"]
    },
    {
        worldName: "무연고장례",
        description: ["세상 뒷면을 굴리는 사람들. 현세의 번뇌와 저승의 사무를 처리하는 명계 공무원들의 일화.", "본편　만화 「무연고장례」"],
        logo: "무연고장례 logo.webp",
        characterData: NecrocomicheCharacters,
        characters: ["Araya", "Kei", "Myu", "Dok", "XXX"]
    },
    {
        worldName: "Residents of AION",
        description: ["신과 인간과 요괴와 기계의 세상. 신앙과 섭리, 신성과 세속의 틈새 속 존재들의 분투기.", "본편　만화 「Residents of AION」제작 예정."],
        logo: "Residents of AION logo.webp",
        characterData: ResidentsOfAIONCharacters,
        characters: ["Synarchy", "Horai", "Odradek", "Ennmaten", "Agartha"]
    }
];

// How far below the top of the character's image the detail box starts.
const DETAIL_TOP_OFFSET = 50;
// On wide windows, the gap between the center of the character and the detail box beside it.
const DETAIL_SIDE_GAP = 100;

function World() {
    const { worldName } = useParams();
    const [hover, setHover] = useState('');
    const [detail, setDetail] = useState(false);
    const [currentCharacter, setCurrentCharacter] = useState('');

    const currentWorld = WORLDS.find(w => w.worldName === worldName);
    const currentWorldCharacters = currentWorld ? currentWorld.characterData : [];
    const imageOffsetOf = (name) => currentWorldCharacters.find(c => c.characterName === name).imageOffset;

    // Top of the detail box: near the top of the character's image, measured from the layout so it holds at any window size.
    const clickedTopOf = (index) => {
        // The button's offsetParent is .World, where the detail container also sits at the top.
        const button = document.getElementById(currentWorldCharacters[index].characterName).parentElement;
        return button.offsetTop + DETAIL_TOP_OFFSET;
    };

    // Where the selected character and its detail box go, from the window width and the character's index.
    const setPosition = (character = "") => {
        let worldWidth = document.getElementById('World').getBoundingClientRect().width;
        let index = 0;

        if (currentCharacter === "") {
            index = currentWorldCharacters.findIndex(c => c.characterName === character);
        } else {
            index = currentWorldCharacters.findIndex(c => c.characterName === currentCharacter);
        }
        let column = Math.floor(worldWidth / 100);
        if (column > currentWorldCharacters.length) { column = currentWorldCharacters.length; }

        if (worldWidth >= 1400) {
            // Put the box beside the character: to its right on the left half, to its left on the right half,
            // and keep it inside the window either way.
            const li = document.getElementById(currentWorldCharacters[index].characterName).closest('li');
            const characterCenter = li.offsetLeft + li.offsetWidth / 2 + currentWorldCharacters[index].imageOffset.x;
            const boxWidth = worldWidth * 0.4 + 20; // #CharacterDetail: width 40% + 10px padding on each side
            let boxLeft = characterCenter < worldWidth / 2 ?
                characterCenter + DETAIL_SIDE_GAP :
                characterCenter - DETAIL_SIDE_GAP - boxWidth;
            boxLeft = Math.min(Math.max(boxLeft, 0), worldWidth - boxWidth);
            return {
                clickedTop: clickedTopOf(index),
                clickedLeft: '0px',
                boxLeft: boxLeft
            };
        }

        // Move the character from its slot to a bit left of center (leaving room for the detail box),
        // measured from the layout so it holds however many characters fit in a row.
        const li = document.getElementById(currentWorldCharacters[index].characterName).closest('li');
        const slotCenter = li.offsetLeft + li.offsetWidth / 2;
        const target = column >= 5 ? worldWidth / 2 - 100 : worldWidth / 2;
        let clickedLeft = Math.round(target - slotCenter) + currentWorldCharacters[index].imageOffset.x;

        return {
            scroll: Math.floor(index / column) * 150 + 100 + (worldWidth - 450) / 2.5,
            clickedTop: clickedTopOf(index),
            clickedLeft: `${clickedLeft}px`,
            boxLeft: `${clickedLeft}px`
        };
    };

    useEffect(() => {
        if (currentCharacter === "") { return; }
        document.getElementById("OC").scrollTo({
            top: setPosition().scroll,
            behavior: "smooth"
        });
    // Only scroll when the selection changes, not on every re-render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentCharacter]);

    if (!currentWorld) return <Navigate to="/OC" replace />;

    const toggleCharacter = (name) => {
        if (detail) {
            setDetail(false);
            setCurrentCharacter("");
        } else {
            setDetail(true);
            setCurrentCharacter(name);
        }
    };

    const closeDetail = () => {
        setDetail(false);
        setCurrentCharacter("");
    };

    const renderDetail = () => {
        const character = currentWorldCharacters.find(c => c.characterName === currentCharacter);
        const position = setPosition();

        return (
            <div id="CharacterDetailContainer">
                <button id="CharacterDetail"
                    style={{
                        left: `${position.boxLeft}px`,
                        top: `${position.clickedTop}px`
                    }}
                    onClick={closeDetail}
                >
                    <p>{character.characterName}</p>
                    <br />

                    <p>GENDER</p>
                    <p>{character.gender}</p>

                    <p>HEIGHT</p>
                    <p>{character.height}</p>

                    <br />
                    <p>{character.position}</p>

                    <br />
                    <p id="Character_Description">{character.description}</p>
                </button>
            </div>
        );
    };

    const isNarrow = window.innerWidth <= 1400;

    return (
      <div className="World hide-scrollbar" id="World">
        {detail && renderDetail()}
        <div>
            <div id="World_Description">
                <img id="World_Logo" src={`/${currentWorld.worldName}/${currentWorld.logo}`} alt={"logo of " + currentWorld.worldName}/>
                <p>
                    {currentWorld.description.map(line => <Fragment key={line}>{line}<br /></Fragment>)}
                </p>
            </div>
            <ul>
                {currentWorld.characters.map(c =>
                    <li key={c}>
                        <button onClick={() => toggleCharacter(c)}
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                height: '500px',
                                marginTop: hover === c ? '0px' : '50px',
                                transition: 'margin-top 0.5s, scale 0.5s, left 0.5s',
                                background: 'none',
                                position: 'relative',
                                zIndex: currentCharacter === c ? '100' : '0',
                                scale: currentCharacter === c ? '1.1' : '1',
                                top: isNarrow ? `${imageOffsetOf(c).y}px` : -50,
                                left: currentCharacter === c ? setPosition().clickedLeft : isNarrow ? `${imageOffsetOf(c).x}px` : 0,
                            }}
                            onMouseEnter={() => setHover(c)}
                            onMouseLeave={() => setHover('')}
                        >
                            <img id={c} src={`/${currentWorld.worldName}/${c}.webp`} alt={c}/>
                        </button>
                    </li>
                )}
            </ul>
        </div>
      </div>
    );
}

export default World;
